"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.LanguagesDropdown = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _overview = _interopRequireDefault(require("@insided/deprecated-control/overview"));

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _DropdownControl = _interopRequireDefault(require("@insided/shared/uikit/dropdown/DropdownControl"));

var _common = require("@insided/shared/utils/common");

var _classnames = _interopRequireDefault(require("classnames"));

var _axios = _interopRequireDefault(require("axios"));

var _OverviewActions = _interopRequireDefault(require("@insided/control/modules/MultiLanguage/Translation/OverviewActions"));

var _Language = _interopRequireDefault(require("@insided/shared/icons/Language"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function getTranslations(_x) {
  return _getTranslations.apply(this, arguments);
}

function _getTranslations() {
  _getTranslations = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(_ref) {
    var _ref$pagination, pagination, _ref$filters, filters, response;

    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _ref$pagination = _ref.pagination, pagination = _ref$pagination === void 0 ? {
              page: 1,
              pageSize: 25
            } : _ref$pagination, _ref$filters = _ref.filters, filters = _ref$filters === void 0 ? {
              search: '',
              language: ''
            } : _ref$filters;
            _context.next = 3;
            return _axios.default.get('/translation/phrases', {
              params: {
                page: pagination.page,
                size: pagination.pageSize,
                query: filters.search,
                language: filters.language
              }
            });

          case 3:
            response = _context.sent;
            return _context.abrupt("return", {
              data: response.data.content,
              total: response.data.total
            });

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getTranslations.apply(this, arguments);
}

var DropdownSelectedItem = function DropdownSelectedItem(_ref2) {
  var options = _ref2.options,
      selectedOption = _ref2.selectedOption;

  if (options.length === 0) {
    return (0, _preact.h)("div", null, "Loading languages...");
  }

  if (selectedOption !== undefined) {
    return (0, _preact.h)("span", {
      className: "selected"
    }, (0, _preact.h)(_Language.default, {
      height: 16,
      width: 16
    }), (0, _preact.h)("div", {
      className: "truncated",
      "aria-label": selectedOption.value
    }, selectedOption.title));
  }

  return (0, _preact.h)("span", null, "Choose a language");
};

var LanguagesDropdown = function LanguagesDropdown(_ref3) {
  var languages = _ref3.languages,
      selectedLanguage = _ref3.selectedLanguage,
      _ref3$hasArrowIcon = _ref3.hasArrowIcon,
      hasArrowIcon = _ref3$hasArrowIcon === void 0 ? true : _ref3$hasArrowIcon;
  return (0, _preact.h)(_DropdownControl.default, {
    align: "adjust",
    className: "language-selector-dropdown",
    triggerClass: "trigger_dropdown",
    items: languages,
    closeOnDropdownClick: true,
    trigger: (0, _preact.h)(_Button.default, {
      title: (0, _preact.h)(DropdownSelectedItem, {
        options: languages,
        selectedOption: selectedLanguage
      }),
      className: (0, _classnames.default)('language-selector', {
        'validation-error': 'error',
        'no-language-selected-message': '!selected'
      }),
      icon: hasArrowIcon ? 'chevronDown' : undefined
    }),
    hideEmptyGroup: true
  });
};

exports.LanguagesDropdown = LanguagesDropdown;

var TranslationsOverview = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(TranslationsOverview, _Component);

  var _super = _createSuper(TranslationsOverview);

  function TranslationsOverview() {
    var _this;

    (0, _classCallCheck2.default)(this, TranslationsOverview);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "isContentInPreferredLanguageEnabled", _common.common.isModuleActive('contentInPreferredLanguage'));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      selectedLanguage: {
        title: _this.props.selectedLanguage ? "".concat(_this.props.selectedLanguage.name).concat(_this.props.selectedLanguage.isDefault ? ' (Default)' : '') : '',
        value: _this.props.selectedLanguage ? _this.props.selectedLanguage.code : ''
      },
      defaultLanguageCode: _this.props.communityLanguage
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "mapLanguagesToDropdownItems", function (languages) {
      var selectedLanguage = _this.state.selectedLanguage;
      return languages.filter(function (language) {
        return selectedLanguage && language.code !== selectedLanguage.value;
      }).map(function (language) {
        return {
          title: "".concat(language.name).concat(language.isDefault ? ' (Default)' : ''),
          onClick: function onClick() {
            return _this.setState({
              selectedLanguage: {
                title: "".concat(language.name).concat(language.isDefault ? ' (Default)' : ''),
                value: language.code
              }
            });
          },
          value: language.locale
        };
      });
    });
    return _this;
  }

  (0, _createClass2.default)(TranslationsOverview, [{
    key: "getColumns",
    value: function getColumns() {
      var _this2 = this;

      return [{
        header: 'Module',
        accessor: 'category',
        size: 's'
      }, {
        header: 'Key',
        accessor: 'message',
        size: 'm'
      }, {
        header: 'Translation',
        accessor: 'translation',
        size: 'm'
      }, {
        header: 'Actions',
        accessor: 'id',
        size: 'xs',
        cell: function cell(_ref4) {
          var id = _ref4.id,
              canEdit = _ref4.canEdit;
          return (0, _preact.h)(_OverviewActions.default, {
            id: id,
            canEdit: canEdit,
            languageCode: _this2.getSelectedLanguageCode()
          });
        }
      }];
    }
  }, {
    key: "getSelectedLanguageCode",
    value: function getSelectedLanguageCode() {
      var _selectedLanguage$val;

      var _this$state = this.state,
          selectedLanguage = _this$state.selectedLanguage,
          defaultLanguageCode = _this$state.defaultLanguageCode;
      return (_selectedLanguage$val = selectedLanguage.value) !== null && _selectedLanguage$val !== void 0 ? _selectedLanguage$val : defaultLanguageCode;
    }
  }, {
    key: "render",
    value: function render() {
      var _selectedLanguage$val2;

      var _this$state2 = this.state,
          selectedLanguage = _this$state2.selectedLanguage,
          defaultLanguageCode = _this$state2.defaultLanguageCode;
      var _this$props = this.props,
          enabledLanguages = _this$props.enabledLanguages,
          publishedLanguages = _this$props.publishedLanguages;
      var enabledLanguagesDropdownItems = enabledLanguages !== null && enabledLanguages !== void 0 && enabledLanguages.length ? this.mapLanguagesToDropdownItems(enabledLanguages) : [];
      var publishedLanguagesDropdownItems = publishedLanguages !== null && publishedLanguages !== void 0 && publishedLanguages.length ? this.mapLanguagesToDropdownItems(publishedLanguages) : [];
      var languages = [{
        groupName: 'Published languages',
        items: publishedLanguagesDropdownItems
      }, {
        groupName: 'Unpublished languages',
        items: enabledLanguagesDropdownItems
      }];
      var hasEnabledOrPublishedLanguages = (enabledLanguages || publishedLanguages) && (enabledLanguages.length > 0 || publishedLanguages.length > 1);
      var showPublishedAndUnpublishedLanguages = this.isContentInPreferredLanguageEnabled && hasEnabledOrPublishedLanguages;
      var addPhraseUrl = "/translation/add?language=".concat(selectedLanguage.value);
      return (0, _preact.h)("div", null, (0, _preact.h)(_overview.default, {
        type: "translation-overview",
        headerTitle: "Phrases Overview",
        withPagination: {
          page: 1,
          pageSize: 25
        },
        rowId: "id",
        model: this.getColumns(),
        withFilters: [],
        withRefreshButton: false,
        AdditionalActionElements: showPublishedAndUnpublishedLanguages ? (0, _preact.h)(LanguagesDropdown, {
          languages: this.isContentInPreferredLanguageEnabled ? languages : enabledLanguagesDropdownItems,
          selectedLanguage: selectedLanguage
        }) : undefined,
        additionalFilters: {
          language: (_selectedLanguage$val2 = selectedLanguage.value) !== null && _selectedLanguage$val2 !== void 0 ? _selectedLanguage$val2 : defaultLanguageCode
        },
        withMultiSelect: false,
        dataSource: getTranslations,
        withSearch: true,
        searchPlaceholder: "Search for key, module or translation",
        headerButtons: [(0, _preact.h)("a", {
          href: (0, _absoluteUrlRuntime.resolveUrl)(addPhraseUrl),
          key: "phrase-add"
        }, (0, _preact.h)(_Button.default, {
          variant: "primary",
          size: "medium"
        }, "Add phrase"))],
        boundedContext: "Translation",
        dataEntity: "Translation overview",
        useFallbackWhenDataEmpty: false
      }));
    }
  }]);
  return TranslationsOverview;
}(_preact.Component);

var _default = TranslationsOverview;
exports.default = _default;